import { Component } from './component.js';
import { PanoViewer } from '@egjs/view360';

export class PanoramicView extends Component {
  static defaultOptions = {
    componentName: 'PanoramicView',
    hfov: 120,
    minHfov: 30,
    maxHfov: 120
  };

  constructor (options) {
    super($.extend({}, PanoramicView.defaultOptions, options));

    this.panoViewer = new PanoViewer(this.el[0], {
      yaw: this.options.yaw - 50,
      pitch: this.options.pitch,
      fov: this.options.hfov,
      useKeyboard: false,
      image: this.options.media
    });

    console.log(this.options);

    $(window).on(
      'mouseup',
      function () {
        $('body').css('cursor', 'default');
        this.el.find('canvas').css('cursor', 'grab');
      }.bind(this)
    );

    this.panoViewer.on(
      'ready',
      function () {
        this.panoViewer.updateViewportDimensions();

        const canvas = this.el.find('canvas');
        canvas.css('cursor', 'grab');

        canvas.on(
          'mousedown',
          function () {
            $('body').css('cursor', 'grabbing');
            canvas.css('cursor', 'grabbing');
          }
        );

        if (this.options.onLoad != null) this.options.onLoad();
      }.bind(this)
    );

    this.panoViewer.on(
      'error',
      function (e) {
        console.log(e);
      }
    );

    this.panoViewer.on(
      'viewChange',
      function (e) {
        if (this.options.onViewChange != null) this.options.onViewChange(e);
      }.bind(this)
    );
  }

  layout () {
    if (this.panoViewer) {
      this.panoViewer.trigger('viewChange');
      this.panoViewer.updateViewportDimensions();
    }
  }

  getPanoViewer () {
    return this.panoViewer;
  }

  panToStart () {
    this.panoViewer.lookAt({ yaw: -20 }, 0);
    this.panoViewer.lookAt({ yaw: 0 }, 2000);
  }

  setZoom (zoom) {
    this.panoViewer.lookAt(
      {
        fov: this.scale(zoom, 0, 5, this.options.maxHfov, this.options.minHfov)
      },
      1000
    );
    console.log('set zoom: ' + zoom);
  }

  setView (e) {
    this.panoViewer.lookAt({ fov: e.fov, yaw: e.yaw, pitch: e.pitch }, 0);
  }

  scale (number, inMin, inMax, outMin, outMax) {
    return ((number - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }
}
